export default function currency(str) {
  if (!str) return ''
  if (str < 0) {
    return `(${(str / -100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })})`
  }
  return (str / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}
